var exports = {
  "iE": "xa15a2ab7--9f27c5--wrapper",
  "kL": "xa15a2ab7--9f27c5--container",
  "pq": "xa15a2ab7--9f27c5--info",
  "DD": "xa15a2ab7--9f27c5--title",
  "h_": "xa15a2ab7--9f27c5--description",
};

module.exports = exports;
